import { isAppMode, type AppMode } from "./types";

const DEFAULT_APP_MODE: AppMode = "demo";

function resolveAppMode(value: string | undefined): AppMode {
  return isAppMode(value) ? value : DEFAULT_APP_MODE;
}

export function getRouteNamespace(_pathname?: string): AppMode | null {
  // Disable namespace-based routing
  return null;
}

export function getRouteMode(_pathname?: string): AppMode {
  return APP_MODE;
}

export function stripModePrefix(pathname: string): string {
  return pathname;
}

export function supportsModePrefixedPath(_path: string): boolean {
  return false;
}

export function toModePath(path: string, _pathname?: string): string {
  // Unified routing: no more /live or /demo prefix
  return path;
}

export const APP_MODE = resolveAppMode(import.meta.env.VITE_APP_MODE);
export const IS_DEMO_MODE = APP_MODE === "demo";
export const IS_LIVE_MODE = APP_MODE === "live";
